var user = sessionStorage.getItem('user');
user = user ? JSON.parse(user) : user;
const initialAuthState = {
    user : user ? user : {},
    error : undefined,
    token : undefined,
    fetching : false
}

export default initialAuthState;